import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * Label/value pairs for a single object.
 *
 * Used where a table of one row used to be — the key lookup result in admin
 * was a `<table>` with no header and one column of `<th>`, which is a
 * description list wearing a table's markup.
 */
export function DescriptionList({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <dl className={cn('divide-y divide-border', className)}>{children}</dl>;
}

export function DescriptionItem({
  label,
  children,
  className,
}: {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('grid gap-1 py-3 sm:grid-cols-[12rem_1fr] sm:gap-4', className)}>
      <dt className="text-sm text-muted-foreground">{label}</dt>
      <dd className="min-w-0 text-sm">{children}</dd>
    </div>
  );
}
